import Vue from 'vue'
import { _SCHEME__UPDATE } from '@/store/mutations'
import { mapMutations } from 'vuex'

interface Data {
  blinkTimers: Record<string, number | undefined>
}

interface Methods {
  [_SCHEME__UPDATE]: () => void
  updateScheme: () => void
  onScrollToCard: (cardNum: number | string) => void
}

export default Vue.extend<Data, Methods, {}, {}>({
  data() {
    return {
      blinkTimers: {},
    }
  },
  methods: {
    ...mapMutations([_SCHEME__UPDATE]),
    updateScheme() {
      this.$nextTick().then(() => {
        this[_SCHEME__UPDATE]()
      })
    },
    onScrollToCard(cardNum: number | string) {
      const targetCard = document.getElementById(`card-container-${cardNum}`)

      if (targetCard) {
        const stringCardNum = String(cardNum)
        const timerId: number | undefined = this.blinkTimers[stringCardNum]

        if (timerId) {
          clearTimeout(timerId)
        }

        targetCard.classList.add('blink')
        this.blinkTimers[stringCardNum] = setTimeout(
          () => targetCard.classList.remove('blink'),
          3000,
        )

        targetCard.scrollIntoView({
          block: 'center',
          inline: 'center',
          behavior: 'smooth',
        })
      }
    },
  },
})
